// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '',
    },
    {
      id: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      type: 'Container',
      name: 'popup',
      className: '',
      x: 335,
      y: 432,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
    },
    {
      id: '95d277a4-48d9-4457-89db-a8b0faa57854',
      type: 'Sprite',
      name: 'background',
      className: '',
      x: 0,
      y: 104,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1.177305,
        y: 1.14,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Big_Pop_Up_Background',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      stateByName: {
        mainMenu: {
          scale: {
            y: 1.171053,
            x: 1,
          },
          y: -8,
          texture: 'Small_Pop_Up_Background',
        },
      },
    },
    {
      id: '31c4b118-6d9a-49a2-bb99-3543ace30601',
      type: 'Sprite',
      name: 'header',
      className: '',
      x: 0,
      y: -341,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 0.85,
        y: 0.85,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Red_Header',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
    },
    {
      id: '69551968-9529-4083-9063-7d6a04eee1ba',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 266,
      y: -330,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None',
      },
      texture: 'Close_Button',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: {
        tapSound: 'UI_Button_Click',
      },
    },
    {
      id: '7df320dd-d16f-47f9-9035-2b1e776c7557',
      type: 'Container',
      name: 'bottomInfo',
      className: '',
      x: 0,
      y: 460,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      stateByName: {
        mainMenu: {
          y: 215,
        },
      },
    },
    {
      id: 'cdcac722-59fa-40d8-80ab-714ae71f49b1',
      type: 'Container',
      name: 'settingsGroups',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
    },
    {
      id: '6110fb58-4e31-43e0-b59e-22367159183d',
      type: 'Text',
      name: 'title',
      className: '',
      x: -3,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'Settings',
      localize: true,
      maxWidth: 380,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 55,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x840025',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '31c4b118-6d9a-49a2-bb99-3543ace30601',
    },
    {
      id: '11b2e37d-9b13-46bf-8524-9cbbeabb9a0b',
      type: 'Text',
      name: 'playerId',
      className: 'variable_SPL',
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -190,
        y: -21,
        width: 380,
        height: 79,
      },
      text: 'VER: <gameVersionToDisplay> ID: <playerId>',
      localize: false,
      maxWidth: 437,
      maxHeight: 57,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 22,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'black',
        stroke: '0x840025',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '7df320dd-d16f-47f9-9035-2b1e776c7557',
      stateByName: {
        noSupportEmail: {
          y: 4,
        },
      },
    },
    {
      id: '3a73b240-15e6-4a5e-a995-d0e0c5598c3e',
      type: 'Text',
      name: 'supportEmailLabel',
      className: '',
      x: 0,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'Contact e-mail:',
      localize: true,
      maxWidth: 535,
      maxHeight: 57,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 22,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x840025',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 20,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '7df320dd-d16f-47f9-9035-2b1e776c7557',
      stateByName: {
        noSupportEmail: {
          visible: false,
        },
      },
    },
    {
      id: 'a374aa6e-a1ee-405b-9466-f12b9b9b3d91',
      type: 'Text',
      name: 'supportEmail',
      className: '',
      x: 0,
      y: 21,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'support@support.com',
      localize: false,
      maxWidth: 535,
      maxHeight: 57,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 22,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x840025',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 20,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '7df320dd-d16f-47f9-9035-2b1e776c7557',
      stateByName: {
        noSupportEmail: {
          visible: false,
        },
      },
    },
    {
      id: 'dcb5f202-bd78-4da5-b49f-51274a0327e8',
      type: 'Text',
      name: 'versionInfo',
      className: '',
      x: 0,
      y: 45,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: '1.0.0',
      localize: false,
      maxWidth: 535,
      maxHeight: 57,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 20,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'black',
        stroke: '0x840025',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 20,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '7df320dd-d16f-47f9-9035-2b1e776c7557',
      stateByName: {
        noSupportEmail: {
          visible: false,
        },
      },
    },
    {
      id: '2ef572b8-1ad2-45ff-8f45-c9e5194adf07',
      type: 'Container',
      name: 'homeButton',
      className: '',
      x: 0,
      y: 351,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None',
      },
      parent: 'cdcac722-59fa-40d8-80ab-714ae71f49b1',
      data: {
        tapSound: 'UI_Button_Click',
      },
      stateByName: {
        mainMenu: {
          visible: false,
        },
      },
    },
    {
      id: '650265cf-0b92-4c54-96f3-e1ba57e9d04c',
      type: 'Container',
      name: 'retryButton',
      className: '',
      x: 0,
      y: 218,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None',
      },
      parent: 'cdcac722-59fa-40d8-80ab-714ae71f49b1',
      data: {
        tapSound: 'UI_Button_Click',
      },
      stateByName: {
        mainMenu: {
          visible: false,
        },
      },
    },
    {
      id: '6e5de9d0-6f85-4b4f-a591-a451e8b2fcee',
      type: 'Container',
      name: 'musicGroup',
      className: '',
      x: -156,
      y: -45,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'cdcac722-59fa-40d8-80ab-714ae71f49b1',
    },
    {
      id: '38045d2e-d584-4d2b-a82d-bcbf7323d1f3',
      type: 'Container',
      name: 'soundGroup',
      className: '',
      x: -156,
      y: -167,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'cdcac722-59fa-40d8-80ab-714ae71f49b1',
    },
    {
      id: '8f087309-2ea2-48db-942c-f414f07513e6',
      type: 'Container',
      name: 'languageGroup',
      className: '',
      x: -156,
      y: 77,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'cdcac722-59fa-40d8-80ab-714ae71f49b1',
    },
    {
      id: 'b8a53e35-01b7-461a-8c16-4433a58d4aca',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 181,
        y: 70,
      },
      width: 362,
      height: 139,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Button_Background',
      parent: '2ef572b8-1ad2-45ff-8f45-c9e5194adf07',
    },
    {
      id: '8195e437-7c93-4ec9-b886-55786031e069',
      type: 'Layout',
      name: '',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: '2ef572b8-1ad2-45ff-8f45-c9e5194adf07',
      data: {
        color: 'green',
      },
    },
    {
      id: '9f1bf242-d214-4779-b6bf-d72e2402d138',
      type: 'Text',
      name: '',
      className: '',
      x: 38,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'Go Back Home',
      localize: true,
      maxWidth: 210,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x006f0d',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '2ef572b8-1ad2-45ff-8f45-c9e5194adf07',
    },
    {
      id: 'a34d29bf-04a3-42f1-b9ab-34a18a5ba1e5',
      type: 'Sprite',
      name: '',
      className: '',
      x: -110,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Back_Home_Green_Button',
      parent: '2ef572b8-1ad2-45ff-8f45-c9e5194adf07',
    },
    {
      id: '3a8d983b-1263-4e98-9e50-a4a66d239892',
      type: 'NineSlicePlane',
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 181,
        y: 70,
      },
      width: 362,
      height: 139,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Button_Background',
      parent: '650265cf-0b92-4c54-96f3-e1ba57e9d04c',
    },
    {
      id: '26fca53f-907b-4ec7-88a4-416563f2fe4f',
      type: 'Layout',
      name: '',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: '650265cf-0b92-4c54-96f3-e1ba57e9d04c',
      data: {
        color: 'red',
      },
    },
    {
      id: '3bfa7443-7e9e-4271-a77f-e109cc490930',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'Retry',
      localize: true,
      maxWidth: 298,
      maxHeight: 91,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x9c1131',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '650265cf-0b92-4c54-96f3-e1ba57e9d04c',
    },
    {
      id: 'eab219c6-d633-4066-bc11-9a60f9437dc0',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Setting_Row_Background',
      parent: '6e5de9d0-6f85-4b4f-a591-a451e8b2fcee',
    },
    {
      id: '7055ab0b-5be2-42f3-ae5e-d752ee06bca5',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Yellow_Hexagon_Button',
      parent: '6e5de9d0-6f85-4b4f-a591-a451e8b2fcee',
    },
    {
      id: '307350f3-dc6e-4d14-855b-6f203a05506e',
      type: 'Sprite',
      name: 'musicToggleButton',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -50,
        y: -50,
        width: 100,
        height: 100,
      },
      texture: 'Music_Icon',
      parent: '6e5de9d0-6f85-4b4f-a591-a451e8b2fcee',
    },
    {
      id: '3d3b470a-8131-49ce-9ed4-c3a7cb8a67b9',
      type: 'Text',
      name: '',
      className: '',
      x: 69,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'Music',
      localize: true,
      maxWidth: 175,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x840025',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '6e5de9d0-6f85-4b4f-a591-a451e8b2fcee',
    },
    {
      id: 'ddcb48ad-dc0a-4ab3-9a7f-bda12a5669ef',
      type: 'Container',
      name: 'musicToggleSlot',
      className: '',
      x: 195,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '6e5de9d0-6f85-4b4f-a591-a451e8b2fcee',
    },
    {
      id: 'b5106d5b-e5a4-46c3-8322-0c8fd2764ab3',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Setting_Row_Background',
      parent: '38045d2e-d584-4d2b-a82d-bcbf7323d1f3',
    },
    {
      id: 'b86678f2-8dfa-400e-9d3f-12cbf4201fab',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Yellow_Hexagon_Button',
      parent: '38045d2e-d584-4d2b-a82d-bcbf7323d1f3',
    },
    {
      id: 'bc83beac-2bb9-4c27-9ccc-fad6a6e32b7c',
      type: 'Sprite',
      name: 'soundToggleButton',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -50,
        y: -50,
        width: 100,
        height: 100,
      },
      texture: 'Sound_Icon',
      parent: '38045d2e-d584-4d2b-a82d-bcbf7323d1f3',
    },
    {
      id: '3560c6c1-c7e6-4016-b1af-e4fb5a91c0db',
      type: 'Text',
      name: '',
      className: '',
      x: 69,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'Sound',
      localize: true,
      maxWidth: 175,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x840025',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '38045d2e-d584-4d2b-a82d-bcbf7323d1f3',
    },
    {
      id: '91b1eac3-c790-4891-ac9b-8483c69e858f',
      type: 'Container',
      name: 'soundToggleSlot',
      className: '',
      x: 195,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '38045d2e-d584-4d2b-a82d-bcbf7323d1f3',
    },
    {
      id: 'a91f2677-cfec-41e9-8596-fe322f9a906f',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Setting_Row_Background',
      parent: '8f087309-2ea2-48db-942c-f414f07513e6',
    },
    {
      id: '5342e0d9-0767-4fbd-9623-e5d2cb7d4782',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Yellow_Hexagon_Button',
      parent: '8f087309-2ea2-48db-942c-f414f07513e6',
    },
    {
      id: '7819f9a2-b0a1-404f-994a-405d0ee802d9',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Settings_Language_Icon',
      parent: '8f087309-2ea2-48db-942c-f414f07513e6',
    },
    {
      id: 'e4c59558-7ad9-40da-bc79-0974a29d5f0d',
      type: 'Text',
      name: '',
      className: '',
      x: 67,
      y: -2,
      anchor: {
        x: 0,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'Language',
      localize: true,
      maxWidth: 175,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x840025',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '8f087309-2ea2-48db-942c-f414f07513e6',
    },
    {
      id: 'f28b0898-a33c-4a61-a9f5-06955abd0283',
      type: 'Container',
      name: 'languageSelectorSlot',
      className: '',
      x: 320,
      y: -1,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '8f087309-2ea2-48db-942c-f414f07513e6',
    },
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: ['noSupportEmail', 'mainMenu'],
  handleResize: false,
} as const;

export class SettingsPopupLayout {
  static raw = raw;
  root!: Container;
  popup!: Container;
  background!: Sprite;
  header!: Sprite;
  closeButton!: Sprite & { data: (typeof raw)['list'][4]['data'] };
  bottomInfo!: Container;
  settingsGroups!: Container;
  title!: Text;
  playerId!: Text;
  supportEmailLabel!: Text;
  supportEmail!: Text;
  versionInfo!: Text;
  homeButton!: Container & { data: (typeof raw)['list'][12]['data'] };
  retryButton!: Container & { data: (typeof raw)['list'][13]['data'] };
  musicGroup!: Container;
  soundGroup!: Container;
  languageGroup!: Container;
  musicToggleButton!: Sprite;
  musicToggleSlot!: Container;
  soundToggleButton!: Sprite;
  soundToggleSlot!: Container;
  languageSelectorSlot!: Container;
  variable_SPL!: Text[];
  StateName!: 'noSupportEmail' | 'mainMenu';

  constructor() {
    console.log('SettingsPopupLayout: Constructing layout from raw data');
    populate(this, raw);
  }
}
